import { Router } from '@angular/router';
import { GetService } from 'src/app/Services/get.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Component, ElementRef, EventEmitter, OnInit, Output} from '@angular/core';
import { environment as env } from 'src/environments/environment';

@Component({
  host: {
    '(document:click)': 'onClick($event)',
  },
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  //for opening and closing sidebar
  @Output() toggleSidebarForMe: EventEmitter<any> = new EventEmitter();
//for rotatating menu icon
  toggleSide:boolean = false;
//for openening and closing notifcations menu
    notifiMenu:boolean = false;
//for openening and closing profile menu
    profileMenu:boolean = false;
    imgUrl;

    User;
  constructor(private _eref: ElementRef,private spinner:NgxSpinnerService, private getser:GetService, private rout:Router ) {}

  ngOnInit(): void {
    this.imgUrl = env.imgUrl;
    this.User = JSON.parse(localStorage.getItem('user'));
  }
  //open profile menu and close notifications menu if opened
  profile(){
    this.profileMenu = !this.profileMenu;
    if (this.notifiMenu = !this.notifiMenu ) {
      this.notifiMenu = false;
    }
  }
// open notifiacations menu and close profile menu if opened
openNotifi(){
  this.notifiMenu = !this.notifiMenu;
  if (this.profileMenu = !this.profileMenu ) {
    this.profileMenu = false;
  }
}
// open and close sideabar on click
  toggleSidebar() {
    this.toggleSidebarForMe.emit();
    this.toggleSide = !this.toggleSide;
  }


//close notifications menu or prifle menu when click outside
  closing() {
    this.profileMenu = false;
    this.notifiMenu = false;
  }

  onClick(event) {
    if (!this._eref.nativeElement.contains(event.target)){
      this.closing();

   }
  }

  logOut(){
    this.spinner.show()
    setTimeout(() => {
      this.spinner.hide()
    }, 1000);
    this.getser.logout();
      this.rout.navigate(['/'])

  }
}


